import { createSelector } from 'reselect';
import ReceptaclePodPerformanceSummaryColumns from '../../containers/ReceptaclePodPerformanceSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.RECEPTACLE_POD_PERFORMANCE_404_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RECEPTACLE_POD_PERFORMANCE_404_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.RECEPTACLE_POD_PERFORMANCE_404_SUMMARY.getDataFunction();

export const getColumns = createSelector(
  getData,
  state => state.userData.userType,
  state => state.reporting.RECEPTACLE_POD_PERFORMANCE_404_SUMMARY.requestParams,
  ReceptaclePodPerformanceSummaryColumns,
);
